module.exports = __webpack_public_path__ + "img/2_OG_ISRM_2023.c28e67f9.png";